// extracted by mini-css-extract-plugin
export default {"background":"styles__background__K6vQM","text":"styles__text__LPgBT"};